<div class="rtimer">
  <p>{{name | uppercase}}</p>
  <p class="middlep">
    <span class="country">{{country}}</span>
    <img class="flag" [src]="'/assets/images/flags/'+country.toLowerCase()+'.png'">
    {{achievement.name }}
  </p>
  <p class="lowerp" *ngIf="achievement.rank===1" >
    NEW
    <span class="type">PR</span>
    <span class="rttime">{{achievement.moving_time | elapsed }}</span>
  </p>
  <p class="lowerp" *ngIf="achievement.rank===2" >
    2nd
    <span class="type">BEST</span>
    <span class="rttime">{{achievement.moving_time | elapsed }}</span>
  </p>
  <p class="lowerp" *ngIf="achievement.rank===3" >
    3rd
    <span class="type">BEST</span>
    <span class="rttime">{{achievement.moving_time | elapsed }}</span>
  </p>
</div>
